module.exports = __webpack_public_path__ + "static/media/IRWIN-1mo-dashboard.fb323683.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/IRWIN-1mo-dashboard.PNG
// module id = 2671
// module chunks = 0